import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="page-footer font-small bg-dark pt-5">
      <div className="container-fluid text-center text-md-left">
      <div className="row p-5 mx-5">
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/aboutus">About Us</Nav.Link>
        </div>
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/gallery">Gallery</Nav.Link>
        </div>
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/mission">Mission</Nav.Link>
        </div>
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/volunteer">Volunteer</Nav.Link>
        </div>
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/donate">Donate</Nav.Link>
        </div>
        <div className="col-md-2 mb-md-0 mb-2">
          <Nav.Link className="text-light" href="/contactus">Contact Us</Nav.Link>
        </div>
      </div>
      </div>

      <div className="text-center"><a className="text-light" href="https://www.youtube.com/watch?v=xh0TAIT8Rx4&t=8s&ab_channel=Code200"><i className="fa-2x fa-brands fa-youtube"></i></a> | <a className="text-light" href="https://www.facebook.com/phprojectdream"><i className="fa-2x fa-brands fa-facebook"></i></a></div>
      <div className="footer-copyright text-center text-light py-3">© 2022 Copyright &nbsp;


      </div>
    </footer>
  );
};

export default Footer;
